import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfigService } from './app-config.service';

import { of } from 'rxjs';
import { CSPaymentsCheckoutView } from '../models/web-payment.model';
@Injectable({
  providedIn: 'root',
})
export class CSPaymentsService {
  vistekUrl: string;
  readonly httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/json',
    }),
  };
  constructor(
    private http: HttpClient,
    private appConfigService: AppConfigService
  ) {
    this.vistekUrl = `${this.appConfigService.vistekUrl}/cart/cspayments/`;
  }

  getCSWebPayment(val: any): Observable<CSPaymentsCheckoutView> {
    return this.http.post<CSPaymentsCheckoutView>(`${this.vistekUrl}GetCSWebPayment`, val, this.httpOptions);
  }

  sendPayPalAuthorizePayment(val: any): Observable<any> {
    return this.http.post(
      `${this.vistekUrl}SendPayPalAuthorizePayment`,
      val,
      this.httpOptions
    );
  }
}
